/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Hero_Title_TailInputs */

const en_portal_hero_title_tail = /** @type {(inputs: Portal_Hero_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With a coach or solo.`)
};

const pl_portal_hero_title_tail = /** @type {(inputs: Portal_Hero_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z trenerem lub solo.`)
};

/**
* | output |
* | --- |
* | "With a coach or solo." |
*
* @param {Portal_Hero_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_hero_title_tail = /** @type {((inputs?: Portal_Hero_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Hero_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_hero_title_tail(inputs)
	return en_portal_hero_title_tail(inputs)
});